import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaTeamsEmbedClient" */ './lazyIndex'),
    { name: 'OwaTeamsEmbedClient' }
);

export const LazyTeamsChatList: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.TeamsChatList
);
